import {useCallback, useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {managementRequest} from 'API/v1/admin/Management';

export function useManagement() {
  const [catalog, setCatalog] = useState({m3us: [], users: [], generatedAt: null});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [feedback, setFeedback] = useState(null);
  const controller = useRef(null);
  const load = useCallback(async () => {
    controller.current?.abort();
    const current = new AbortController();
    controller.current = current;
    setLoading(true);
    setError('');
    try {
      const data = await managementRequest('/management', undefined, 'get', current.signal);
      if (!Array.isArray(data?.m3us) || !Array.isArray(data?.users))
        throw new Error('La respuesta del servidor no es válida.');
      if (!current.signal.aborted) setCatalog(data);
    } catch (failure) {
      if (!current.signal.aborted) setError(failure.message);
    } finally {
      if (!current.signal.aborted) setLoading(false);
    }
  }, []);
  useEffect(() => {
    load();
    return () => controller.current?.abort();
  }, [load]);
  const saved = (result, message) => {
    setFeedback({
      severity: result.warnings?.length ? 'warning' : 'success',
      message: result.warnings?.join(' ') || message
    });
    load();
  };
  return {...catalog, loading, error, load, saved, feedback, setFeedback};
}

export function useManagementFilters(defaults) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const filters = Object.fromEntries(
    Object.entries(defaults).map(([key, value]) => [key, params.get(key) || value])
  );
  const update = (values) => {
    Object.entries(values).forEach(([key, value]) => {
      if (value === defaults[key] || !value) params.delete(key);
      else params.set(key, value);
    });
    // Explicit pathname avoids duplicating /frontend with router 6.11.
    navigate(
      {pathname: location.pathname, search: params.toString() ? `?${params}` : ''},
      {replace: true}
    );
  };
  return [
    filters,
    update,
    () => navigate({pathname: location.pathname, search: ''}, {replace: true})
  ];
}
